import { connect } from 'react-redux';
import PickupTimeHome from './pickup-time-home';
import {selectPickupTime,fetchPickupTimeRange} from "./pickupTimeSlice"

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPickupTimeRange: () => {
      dispatch(fetchPickupTimeRange());
    },
    setSelectedPickupTime: (pickupTime) => {
      dispatch(selectPickupTime(pickupTime));
    },
    

};
}

const mapStateToProps = ({pickupTime,appState }) => {
  return {
    pickupTimeStore:pickupTime,
    appState
  };
};
export default connect(mapStateToProps,mapDispatchToProps)(PickupTimeHome);
